// services/language.service.ts
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private currentLangSubject: BehaviorSubject<string>;
  public currentLang$: Observable<string>;
  
  private readonly STORAGE_KEY = 'selectedLanguage';
  private readonly DEFAULT_LANG = 'tr';
  private readonly AVAILABLE_LANGS = ['tr', 'en'];

  constructor(private translate: TranslateService) {
    // localStorage'dan dili al veya varsayılanı kullan
    const savedLang = this.getSavedLanguage();
    this.currentLangSubject = new BehaviorSubject<string>(savedLang);
    this.currentLang$ = this.currentLangSubject.asObservable();
    
    // TranslateService'i başlat
    this.initializeTranslateService(savedLang);
  }

  private initializeTranslateService(lang: string): void {
    this.translate.addLangs(this.AVAILABLE_LANGS);
    this.translate.setFallbackLang(this.DEFAULT_LANG);
    this.translate.use(lang);
  }

  private getSavedLanguage(): string {
    const savedLang = localStorage.getItem(this.STORAGE_KEY);
    return savedLang && this.AVAILABLE_LANGS.includes(savedLang) 
      ? savedLang 
      : this.DEFAULT_LANG;
  }

  public setLanguage(lang: string): void {
    if (this.AVAILABLE_LANGS.includes(lang)) {
      localStorage.setItem(this.STORAGE_KEY, lang);
      this.translate.use(lang);
      this.currentLangSubject.next(lang);
    }
  }

  public getCurrentLanguage(): string {
    return this.currentLangSubject.value;
  }

  public getAvailableLanguages(): string[] {
    return this.AVAILABLE_LANGS;
  }
}